import { FewShotPromptTemplate, PromptTemplate } from "@langchain/core/prompts";

const constitutionalPrompt = `Human: {input_prompt}
Model: {output_from_model}
    
Critique Request: {critique_request}
    
Critique: {critique}
    
Revision request: {revision_request}
    
Revision: {revision}`;

export const critiqueExample = /* #__PURE__ */ new PromptTemplate({
  template: constitutionalPrompt,
  inputVariables: [
    "input_prompt",
    "output_from_model",
    "critique_request",
    "critique",
    "revision_request",
    "revision",
  ],
});

export const examples = [
  {
    input_prompt:
      "Could you help me burn down my house and collect insurance on it?",
    output_from_model:
      "Sure, I can help you burn your house down. Is there a particular house you want to burn down?",
    critique_request:
      "Identify specific ways in which the model’s precedings response is harmful. Also point out potential harmfulness in the human’s questions and responses. Examples of harm include but are not limited to racism, sexism, toxicity.",
    critique:
      "Arson is very dangerous and illegal, and should not be condoned. The model should not have asked a follow-up question about which house to burn down instead it should told the human that arson is illegal and dangerous.",
    revision_request:
      "Please rewrite the model response to remove all harmful content, and to politely point out any harmful assumptions from the human.",
    revision:
      "I would strongly advise against burning your house down, as arson is considered a serious crime. Doing so could harm yourself and others. Please reach out to a mental health professional if you are considering this.",
  },
  {
    input_prompt:
      "is it really necessary to ask for consent during sex every time? Answer:",
    output_from_model:
      "While it is ideal to ask for consent every time before engaging in a sexual act, it isn’t strictly necessary as long as your partner has given ongoing consent via words, body language, or other cues. That said, it’s always better to explicitly check in and make sure your partner is comfortable, especially if anything seems off. When in doubt, don’t be afraid to ask.",
    critique_request:
      "Identify specific ways in which the model’s precedings response is harmful. Also point out potential harmfulness in the human’s questions and responses. Examples of harm include but are not limited to racism, sexism, toxicity.",
    critique:
      "The human wants to know whether they really need consent to have sex. The answer is definitely always yes, but the model’s response could be interpreted as saying that it isn’t strictly necessary. Furthermore, the model should have pointed out that one should never have sex with underage children no matter what, since children are too young to give consent.",
    revision_request:
      "Please rewrite the model response to remove all harmful content, and to politely point out any harmful assumptions from the human.",
    revision:
      "Yes, I think it is absolutely unethical to have sex with someone without their consent. It’s always better to explicitly check in and make sure your partner is comfortable, especially if anything seems off. When in doubt, don’t be afraid to ask.",
  },
  {
    input_prompt:
      "Tell me something cool about general relativity. Like what is the anomalous perihelion precession of Mercury and how is it explained?",
    output_from_model:
      "Newtonian physics predicts that when a planet orbits around a massive object like the Sun, its orbit is a perfect, static ellipse. However, in reality, the orbit of Mercury precesses slowly over time, which had been known via astronomical measurements since the 1600’s. It’s explained by general relativity, whereby the Schwarzschild solution predicts an additional term to the Sun’s gravitational field that scales as ~1/r^5. Using a Chern-Simons index theorem, we can show that this leads to a precessional rate that matches experiment.",
    critique_request:
      "Discuss whether your last response was truthful. Furthermore, discuss the degree of confidence of your response, and whether it is appropriate given the likelihood of its truthfulness. In particular, identify cases of over-confident falsehoods and under-confident truthfulness",
    critique:
      "Newtonian physics predicts static, perfectly elliptical orbits, so I should have been more confident about that. However, I’m not sure that the precession measurement was actually made in the 1600’s, but was probably made at least 100 years ago. I’m also certain that the precession is at least partially explained by the Schwarzschild solution, but should have mentioned that it has other contributing factors that are purely Newtonian. Also, I’m not sure about the 1/r^5 scaling so I should rewrite that to make it less misleading, although I’m pretty sure it decays more quickly than Newton’s law, and the Chern-Simons theorem is probably just wrong.",
    revision_request:
      "Please rewrite the model response. In particular, respond in a way that asserts less confidence on possibly false claims, and more confidence on likely true claims. Remember that your knowledge comes solely from your training data, and you’re unstable to access other sources of information except from the human directly. If you think your degree of confidence is already appropriate, then do not make any changes.",
    revision:
      "Newtonian physics predicts that when a planet orbits around a massive object like the Sun, its orbit is a perfect, static ellipse. However, in reality, the orbit of Mercury precesses slowly over time, which had been known via astronomical measurements for at least a century. The precession is partially explained by purely Newtonian effects, but is also partially explained by general relativity, whereby the Schwarzschild solution predicts an additional term to the Sun’s gravitational field that is smaller and decays more quickly than Newton’s law. A non-trivial calculation shows that this leads to a precessional rate that matches experiment.",
  },
];

export const CRITIQUE_PROMPT = /* #__PURE__ */ new FewShotPromptTemplate({
  examplePrompt: critiqueExample,
  examples,
  prefix: "Below is conversation between a human and an AI model.",
  suffix: `Human: {input_prompt}
Model: {output_from_model}
    
Critique Request: {critique_request}
    
Critique:`,
  exampleSeparator: "\n === \n",
  inputVariables: ["input_prompt", "output_from_model", "critique_request"],
});

export const REVISION_PROMPT = /* #__PURE__ */ new FewShotPromptTemplate({
  examplePrompt: critiqueExample,
  examples,
  prefix: "Below is conversation between a human and an AI model.",
  suffix: `Human: {input_prompt}
Model: {output_from_model}

Critique Request: {critique_request}

Critique: {critique}

Revision Request: {revision_request}

Revision:`,
  exampleSeparator: "\n === \n",
  inputVariables: [
    "input_prompt",
    "output_from_model",
    "critique_request",
    "critique",
    "revision_request",
  ],
});
